module.exports = __webpack_public_path__ + "media/images/product/f_f-0437216a4eb2019373ac9316e237fc08.png";